import React, { useState } from 'react'
import ContainerFilters from './ContainerFilters'
import Button from '../../../../components/Buttons/Button'
import { MdOutlineTune } from 'react-icons/md'
import SideBar from '../../../../components/SideBar/SideBar'

const Filters = () => {
    const [isSideBarOpen, setIsSideBarOpen] = useState(false);

    const handleCloseSidebar = () => {
        setIsSideBarOpen(false);
    };

    return (
        <div className='lg:w-[20.375rem]'>
            {/* Vista móvil con sidebar */}
            <div className='lg:hidden mt-10 relative mb-6'>
                <Button
                    label="FILTRO"
                    icon={MdOutlineTune}
                    showIconRight={true}
                    showIconLeft={false}
                    onClick={() => setIsSideBarOpen(true)}
                    className="border border-system-light-20 rounded-md bg-brand-green-15 text-primary-100 text-tmedium !h-full !p-4 !w-full justify-between"
                    iconSize={18}
                />

                <SideBar isOpen={isSideBarOpen} onClose={handleCloseSidebar}>
                    {isSideBarOpen && (
                        <ContainerFilters onApply={handleCloseSidebar} />
                    )}
                </SideBar>
            </div>
            {/* Vista desktop */}
            <div className="hidden lg:block w-[20.375rem]">
                <ContainerFilters />
            </div>
        </div>
    )
}

export default Filters